'use client';
import { cn } from '../cn';
import type { PrimaryAction, DateRange } from './document-list-shell-types';
import { DocumentListShellPeriod } from './document-list-shell-period';

interface HeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  primaryAction?: PrimaryAction;
  period?: DateRange;
  onPeriodChange?: (p: DateRange) => void;
  hidePeriodSelector?: boolean;
  headerActions?: React.ReactNode;
}

/**
 * PageHeader pentru DocumentListShell: titlu (h1), subtitle, period selector,
 * primary action button. Layout flex care wrap-uie pe mobile.
 */
export function DocumentListShellHeader({
  title,
  subtitle,
  primaryAction,
  period,
  onPeriodChange,
  hidePeriodSelector,
  headerActions,
}: HeaderProps) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-3 px-2 pt-2">
      <div className="min-w-0 flex-1">
        <h1 className="text-[1.375rem] font-bold uppercase tracking-wide text-neutral-900 leading-tight">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-neutral-500">{subtitle}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {!hidePeriodSelector && period && onPeriodChange && (
          <DocumentListShellPeriod period={period} onChange={onPeriodChange} />
        )}
        {headerActions}
        {primaryAction && (
          primaryAction.href ? (
            <a
              href={primaryAction.href}
              className={cn(
                'inline-flex items-center gap-1.5 rounded-md border border-primary-600 bg-primary-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm transition-colors',
                'hover:border-primary-700 hover:bg-primary-700',
                'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
              )}
            >
              {primaryAction.icon}
              {primaryAction.label}
            </a>
          ) : (
            <button
              type="button"
              onClick={primaryAction.onClick}
              className={cn(
                'inline-flex items-center gap-1.5 rounded-md border border-primary-600 bg-primary-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm transition-colors',
                'hover:border-primary-700 hover:bg-primary-700',
                'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
              )}
            >
              {primaryAction.icon}
              {primaryAction.label}
            </button>
          )
        )}
      </div>
    </header>
  );
}
